import { IUser } from '@interfaces/user';
import { useApiUrl, useCustom } from '@refinedev/core';
import { useMemo } from 'react';

/** Actor ids -> display names through `v1/users/by-ids` (same call as the subscription report). */
export const useSaSmsUserNames = (
    ids: Array<string | null | undefined>,
): Record<string, string> => {
    const apiUrl = useApiUrl();
    const unique = useMemo(
        () => Array.from(new Set(ids.filter((i): i is string => !!i))).sort(),
        [ids.join(',')],
    );
    const { data } = useCustom<IUser.IUserDto[]>({
        url: `${apiUrl}/v1/users/by-ids`,
        method: 'post',
        config: { payload: { ids: unique, withDeleted: true } },
        queryOptions: { enabled: unique.length > 0, queryKey: ['sa-sms-users', unique] },
        errorNotification: false,
    });
    return useMemo(() => {
        const map: Record<string, string> = {};
        (data?.data ?? []).forEach((u) => {
            if (u.id)
                map[u.id] = [u.firstName, u.lastName].filter(Boolean).join(' ') || u.email || u.id;
        });
        return map;
    }, [data]);
};
